/**
 * Called from the RAF loop, NOT on every keystroke.
 * All inputs are primitives — no object allocation in the hot path.
 */

export interface TypingMetrics {
  wpm: number;
  cpm: number;
  accuracy: number;
  errorCount: number;
  elapsedMs: number;
}

export const EMPTY_METRICS: TypingMetrics = {
  wpm: 0,
  cpm: 0,
  accuracy: 100,
  errorCount: 0,
  elapsedMs: 0,
};

export function calculateMetrics(
  currentIndex: number,
  errorCount: number,
  startTimestamp: number,
): TypingMetrics {
  const elapsedMs = performance.now() - startTimestamp;
  const elapsedMinutes = elapsedMs / 60_000;

  const wpm =
    elapsedMinutes > 0
      ? Math.round(currentIndex / 5 / elapsedMinutes)
      : 0;

  const cpm =
    elapsedMinutes > 0
      ? Math.round(currentIndex / elapsedMinutes)
      : 0;

  const accuracy =
    currentIndex > 0
      ? Math.round(((currentIndex - errorCount) / currentIndex) * 1000) / 10
      : 100;

  return { wpm, cpm, accuracy, errorCount, elapsedMs };
}
